import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MapV3Component } from '../map-v3/map-v3.component';
import { MAP_CONSTANTS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { MapComponentService, MapLegendItem } from '../map/map.component.service';
import * as _ from 'underscore';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';

@Component({
	selector: 'app-map-v3-beta',
	templateUrl: './map-v3-beta.component.html',
	styleUrls: ['./map-v3-beta.component.css'],
	providers: [MapComponentService]
})
export class MapV3BetaComponent extends MapV3Component implements OnInit, OnDestroy {
	@Input() showthirdpartyrtg: any;
	@Input() uniqueoverwriteid: string;
	protected GF_PRODUCTS = [
		{
			productName: 'GeoFence',
			productKey: MAP_CONSTANTS.STATE.GEOFENCE,
			showInLegend: true,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			mergeFrom: {
				fields: ['impressions', 'clicks', 'ctr'],
				key: 'georecency'
			},
			flag: ['hasDisplay']
		},
		{
			productName: 'Georecency',
			productKey: 'georecency',
			showInLegend: false,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasDisplay']
		},
		{
			productName: 'GeoVideo',
			productKey: MAP_CONSTANTS.STATE.GEOVIDEO,
			showInLegend: true,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasPreroll'],
			productRelated: 'Preroll'
		},
		{
			productName: 'GeorecencyPreroll',
			productKey: 'georecencyPreroll',
			showInLegend: false,
			show: false,
			isDependent: true,
			isDisabled: false,
			isSelected: true,
			flag: ['hasPreroll'],
			productRelated: 'Preroll'
		}
	];

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService, mapComponentService, AnalyticsDataChachingService);
	}

	ngOnInit() {
		super.ngOnInit();
	}
	ngOnDestroy() {
		super.ngOnDestroy();
	}

	protected processLegendSelection(item?) {
		const nonDependentLegendItems = _.where(this.legendItems, { isDependent: false });
		const gfProduct =
			item.productKey === 'geofence' || item.productKey === 'display'
				? _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOFENCE })
				: _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOVIDEO });
		const selectedLegendItems = _.where(nonDependentLegendItems, { isSelected: true });
		if (selectedLegendItems.length === 0) {
			this.hasOnlyGeoFenceSelected = gfProduct ? gfProduct.isSelected : false;
			if (this.hasOnlyGeoFenceSelected) {
				this.noRegionData = false;
			} else {
				this.noRegionData = true;
			}
		}
		if (gfProduct) {
			this.toggleGeoFenceData(gfProduct.isSelected, gfProduct);
		}
	}

	public selectedProductDetails(legendItem: MapLegendItem) {
		legendItem.isSelected = !legendItem.isSelected;
		if (
			legendItem.productKey &&
			(legendItem.productKey === MAP_CONSTANTS.STATE.DISPLAY ||
				legendItem.productKey === MAP_CONSTANTS.STATE.GEOFENCE ||
				legendItem.productKey === MAP_CONSTANTS.STATE.PREROLL ||
				legendItem.productKey === MAP_CONSTANTS.STATE.GEOVIDEO)
		) {
			this.dependentProductSelection(legendItem);
		}
		this.processLegendSelection(legendItem);
		if (!legendItem.isDependent) {
			this.updateSelectedRegionsOnProductSelection();
			this.refreshMap();
		}
		this.drawCenter();
	}

	// Geofenec is subproduct of Display: On the selection of geofenc only or display + geoefnce campaigns, selectig or deselecting of display and geofence products

	protected dependentProductSelection(item) {
		const displayProduct = _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.DISPLAY });
		const geofenceProduct = _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOFENCE });
		const prerollProduct = _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.PREROLL });
		const geovideoProduct = _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOVIDEO });
		switch (item.productKey) {
			case MAP_CONSTANTS.STATE.DISPLAY:
				geofenceProduct.isSelected = item.isSelected
					? this.mapComponentService.displayGeorecencyObj.features.length ||
					  this.mapComponentService.displayGeofenceObj.features.length > 0
					: false;
				break;

			case MAP_CONSTANTS.STATE.GEOFENCE:
				displayProduct.isSelected = !item.isSelected
					? this.mapComponentService.displayRegions.length == 0
						? false
						: displayProduct.isSelected
					: displayProduct.isSelected;
				break;
			case MAP_CONSTANTS.STATE.PREROLL:
				geovideoProduct.isSelected = item.isSelected
					? this.mapComponentService.prerollGeorecencyObj.features.length ||
					  this.mapComponentService.prerollGeofenceObj.features.length > 0
					: false;
				break;

			case MAP_CONSTANTS.STATE.GEOVIDEO:
				prerollProduct.isSelected = !item.isSelected
					? this.mapComponentService.prerollRegions.length == 0
						? false
						: prerollProduct.isSelected
					: prerollProduct.isSelected;
				break;
		}
	}
}
